export enum FilterFieldType {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  TIMEZONE = 'timezone',
  DROPDOWN = 'dropdown',
  MULTI_SELECT = 'multi-select',
  AUTOCOMPLETE = 'autocomplete',
  SET_FILTER = 'set',
  TREE_VIEW_FILTER = 'tree-view',
  BOOLEAN = 'boolean'
}
